// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"0760f7f4","117":"47de4b9f","488":"8476d5fc","585":"fd2458d2","621":"c4f8235a","699":"ae936ae8","706":"7f2c57cf","787":"749b4a44","815":"d74f56dd"}[chunkId] + ".chunk.js";
};